import style from "./AcknowledgmentForApp.module.scss";
import { useDynamicContentLoader } from "../../../hooks/useDynamicContentLoader/useDynamicContentLoader";
import { DynamicContentRenderer } from "../../DynamicContentRenderer/DynamicContentRenderer";

const AcknowledgmentForAppMode = () => {
  const { htmlContent, isLoading, error } = useDynamicContentLoader({
    contentPattern: "acknowledgement.dita",
  });

  return (
    <DynamicContentRenderer
      htmlContent={htmlContent}
      isLoading={isLoading}
      error={error}
      loadingMessage="Loading acknowledgements..."
      containerClass={style.acknowledgementsContainer}
      contentClass={style.acknowledgementsContent}
    />
  );
};

export default AcknowledgmentForAppMode;
